import { FC, ReactElement } from 'react';

import { LinkButton, SafeHtml } from '../../../../../components';
import { VisualCarouselSlideInterface } from '../../../../../entities/@sections/VisualCarousel/VisualCarousel';

import './HalfWidthVisualCarouselSlideText.scss';

export interface HalfWidthVisualCarouselSlideTextProps extends VisualCarouselSlideInterface {
    className?: string;
}

const HalfWidthVisualCarouselSlideText: FC<HalfWidthVisualCarouselSlideTextProps> = ({
    title,
    paragraphHtml,
    links,
    className = '',
}): ReactElement => (
    <div className={`half-width-visual-carousel-slide-text ${className}`}>
        <h3 className="half-width-visual-carousel-slide-text__title">
            {title}
        </h3>

        <SafeHtml
            html={paragraphHtml}
            className="half-width-visual-carousel-slide-text__description"
        />

        {links.length > 0 && (
            <div className="half-width-visual-carousel-slide-text__link-button-wrapper">
                {links.map(link => (
                    <LinkButton
                        key={link.path}
                        to={link.path}
                        text={link.label}
                        className="half-width-visual-carousel-slide-text__link-button"
                    />
                ))}
            </div>
        )}
    </div>
);

export default HalfWidthVisualCarouselSlideText;
